<template>
  <v-dialog v-model="dialog" max-width="1000">
    <template v-slot:activator="{ on }">
      <mf-button label="Alterar números disparadores" icon="autorenew" color="marca-0-l40" text @click="handleDialog($event, on.click)" />
    </template>

    <v-card class="pa-4">
      <div class="title-close-container">
        <span class="mf-card-title">Alterar números disparadores</span>
        <mf-button type="icon" icon="close" color="cinza-d20" @click="close" />
      </div>

      <mf-info-card class="mt-6" description="Apenas os consumidores que se cadastraram através dos números selecionados irão receber essa campanha." />

      <v-data-table
        v-model="localSelectedNumbers"
        :loading="$apollo.queries.numbersQuery.loading"
        class="mt-8"
        :headers="headers"
        :items="items"
        item-key="number"
        show-select
        hide-default-footer
        disable-pagination
        fixed-header
        :height="tableHeight"
      >
        <template v-slot:item.number="{ item }">
          <span>{{ item.number | telefone }}</span>
        </template>
        <template v-slot:item.nof_contacts="{ item }">
          {{ item.nof_contacts | localeString(0) }}
        </template>
        <template v-slot:item.status="{ item }">
          <div class="d-flex flex-row align-center">
            <mf-icon fill small :color="statusColor(item.connection_status)">fiber_manual_record</mf-icon>
            {{ statusText(item.connection_status) }}
          </div>
        </template>
      </v-data-table>

      <mf-action-buttons
        class="mt-4 mb-2"
        :primary-button="{
          text: 'Salvar',
          action: save,
          isVisible: true,
          isDisabled: false,
        }"
        :cancel-button="{
          text: 'Cancelar',
          action: close,
          isVisible: true,
          isDisabled: false,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { QUERY_GET_NUMBERS } from '@/modules/campanhas/whatsapp/graphql/index.js'
import whatsappStatusMixin from '@/modules/campanhas/whatsapp/mixins/whatsapp-status.js'
export default {
  mixins: [whatsappStatusMixin],
  props: {
    preSelectedNumbers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    localSelectedNumbers: [],
    headers: [
      { text: 'Nome', value: 'name' },
      { text: 'Número', value: 'number' },
      { text: 'Contatos', value: 'nof_contacts' },
      { text: 'Status', value: 'status' },
    ],
    items: [],
  }),
  computed: {
    tableHeight() {
      if (this.items.length >= 12) {
        return 600
      }
      return (this.items.length + 1) * 48
    },
  },
  apollo: {
    numbersQuery: {
      query: QUERY_GET_NUMBERS,
      update({ getNumbers }) {
        this.items = getNumbers.map((number) => ({
          ...number,
          statusIconVariant: number?.connection_status?.toLowerCase() || '',
          status: this.formatStatus(number?.connection_status?.toLowerCase()),
        }))
        return getNumbers
      },
    },
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.localSelectedNumbers = this.preSelectedNumbers || []
      }
    },
  },
  mounted() {
    this.localSelectedNumbers = this.preSelectedNumbers || []
  },
  methods: {
    formatStatus(status) {
      switch (status) {
        case 'online':
          return 'Online'
        case 'offline':
          return 'Offline'
        case 'connecting':
          return 'Conectando'
        case 'unstable':
          return 'Instável'
        case 'inactive':
          return 'Inativo'
        default:
          return 'Desconhecido'
      }
    },
    handleDialog() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    save() {
      this.$emit('save', this.localSelectedNumbers)
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.title-close-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

::v-deep .v-data-table-header {
  font-weight: bold;
  font-size: 14px;
  background-color: $cinza-l80;
  color: $cinza-d60;
}
</style>
